const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl:   '.swiper-button-next',
		prevEl:   '.swiper-button-prev',
		addIcons: false
	}
});

document.querySelectorAll('.module-slideshow').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-cards').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-contenuti').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		pagination:    {
			el:   ".swiper-pagination",
			type: "fraction"
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-video').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-prodotti').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-referenze').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
			}
		}
	});
});

document.querySelectorAll('.module-slideshow-articoli').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 'auto',
		spaceBetween:  12,
		navigation:    {
			nextEl:   section.querySelector('.swiper-button-next'),
			prevEl:   section.querySelector('.swiper-button-prev'),
			addIcons: false,
		},
		breakpoints:   {
			992: {
				spaceBetween: 24,
				grid:         {
					rows: 2,
				}
			}
		}
	});
});

document.querySelectorAll('.module-documenti-rassegna-stampa').forEach((section) => {
	new Swiper(section.querySelector('.swiper'), {
		slidesPerView: 1,
		spaceBetween:  0,
		pagination:    {
			el:           ".swiper-pagination",
			clickable:    true,
			renderBullet: function (index, className) {

				let number    = index + 1;
				let formatted = String(number).padStart(2, '0');

				return '<span class="' + className + '">' + formatted + '</span>';
			}
		},
		on: {
			lock(swiper) {
				swiper.el.classList.add('is-static');
			}
		}
	});
});


let approfondimentoProdottiSwiper = new Swiper('.approfondimento-prodotti .swiper', {
	slidesPerView: 'auto',
	speed:         600,
	loop:          true,
	autoplay:      prefersReducedMotion ? false : {
		delay:                3000,
		disableOnInteraction: false
	},
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
});

let riveditoriSearchSwiper = new Swiper('.rivenditori-search .swiper', {
	slidesPerView: 'auto',
	speed:         600,
	loop:          true,
	autoplay:      prefersReducedMotion ? false : {
		delay:                3000,
		disableOnInteraction: false
	},
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
});

const swiperAutoplayToggles = document.querySelectorAll('.swiper-autoplay-toggle');

swiperAutoplayToggles.forEach(function (el) {
	const swiper = el.closest('.swiper').swiper;

	if (!prefersReducedMotion)
	{
		swiper.autoplay.start();
	}
	else
	{
		el.textContent = 'Play';
		el.setAttribute('aria-pressed', 'true');
	}

	el.addEventListener('click', function () {

		if (swiper.autoplay.running)
		{
			swiper.autoplay.stop();
			el.setAttribute('aria-pressed', 'true');
		}
		else
		{
			swiper.autoplay.start();
			el.setAttribute('aria-pressed', 'false');
		}

	});
});